module.exports = __webpack_public_path__ + "static/img/purple_animate1.f9241600.png";